<template>
    <div style="overflow-x: scroll; width: 100%">
        <v-data-table
            style="min-width: min-content"
            v-model="selected"
            :headers="headers"
            :items="entities"
            :options="{ itemsPerPage: 30 }"
            :search="search"
            item-key="id"
            class="elevation-1 pa-3"
        >
            <!-- Customer number format for concentration -->
            <template v-slot:item.concentration="{ item }">
                {{ numberFormatter.format(item.concentration) }} {{ item.concentration_units }}
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { defineComponent } from "vue";

import { withLoadingScreen } from "@/lib/loading";
import { useToast } from "vue-toastification";
import { fetchThingsDataSchemaAndGlobals } from "@/lib/legacyThingUtils.js";

const numberFormatter = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 });

export default defineComponent({
    name: "EntityList",

    setup() {
        return {
            toast: useToast(),
        };
    },

    props: {
        experiment: {
            type: Object,
            required: true,
        },
        protocol: {
            type: Object,
            required: false,
        },
        thingSchema: {
            type: Object,
            required: false,
        },
        search: {
            type: String,
            default: undefined,
        },
        isUsingMeasurements: {
            type: Boolean,
            required: true,
        },
    },

    async created() {
        await this.fetch();
    },

    data() {
        return {
            headers: [],
            entities: [],
            numberFormatter,
            selected: [],
            showConfirmDeleteDialog: false,
            formData: [],
            // Note: this is the attribute object/map
            schema: {},
            globalRelationMap: {},
            entryRelationMap: {},
        };
    },

    computed: {
        capitalizedEntityName() {
            return this.thingSchema.displayName;
        },
        entityName() {
            return this.thingSchema.name;
        },
        entityParent() {
            return this.thingSchema.parentThingSchemaName;
        },
    },

    methods: {
        async fetch() {
            await withLoadingScreen(async () => {
                const { schema, entityDataMap, globalMapObject } =
                    await fetchThingsDataSchemaAndGlobals({
                        protocolCode: this.protocol.code,
                        experimentCode: this.experiment.code,
                        entityName: this.thingSchema.name,
                        parent: this.thingSchema.parentThingSchemaName,
                    });

                this.headers = [
                    { title: "Entity Name", value: "display_name" },
                    { title: "Entity Id", value: "id" },
                ];

                // Create headers from schema attributes
                Object.keys(schema).forEach((attributeName) => {
                    const attribute = schema[attributeName];
                    const header = {
                        title: attribute.display_name,
                        value: attribute.name,
                    };
                    this.headers.push(header);
                });
                this.schema = schema;
                this.entities = entityDataMap;
                this.globalRelationMap = globalMapObject;
            }, `Loading ${this.capitalizedEntityName} Entities`);
        },
    },
});
</script>

<style scoped>
.actions {
    position: absolute;
    top: 85px;
    right: 60px;
}
</style>
